// Simple Google Analytics / Firebase Analytics wrapper
// Uses gtag, which should already be loaded on lokobee.com

type AnalyticsParams = Record<string, unknown>;

export const trackEvent = (eventName: string, params: AnalyticsParams = {}): void => {
  if (typeof window === 'undefined') {
    return;
  }

  const w = window as any;

  if (!w.gtag || !process.env.REACT_APP_GOOGLE_TAG_ID) {
    return;
  }

  w.gtag('event', eventName, {
    send_to: process.env.REACT_APP_GOOGLE_TAG_ID,
    ...params,
  });
};

// Common ecommerce helpers (optional, but convenient)

export const trackAddToCart = (params: AnalyticsParams): void => {
  trackEvent('add_to_cart', params);
};

export const trackBeginCheckout = (params: AnalyticsParams): void => {
  trackEvent('begin_checkout', params);
};

export const trackPurchase = (params: AnalyticsParams): void => {
  trackEvent('purchase', params);
};

export const trackOrderTypeSelection = (params: AnalyticsParams): void => {
  trackEvent('select_order_type', params);
};